'use strict';

module.exports = require('es5-ext/object/primitive-set')('key',
	'value', 'key+value');



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/es6-map/lib/iterator-kinds.js
// module id = ../../../../es6-map/lib/iterator-kinds.js
// module chunks = 4